import React, { useMemo } from 'react';
import styled from 'styled-components/macro';
import scaleSize from 'utils/scale-size';

const HALF_OF_HOUR = 30 * 60 * 1000;
const THRESHOLD_IN_PIXELS = scaleSize(400);

const BlockWrapper = styled.div`
  position: absolute;
  width: ${scaleSize(1740)}px;
  top: ${scaleSize(216)}px;
  left: ${scaleSize(400)}px;
`;

const StyledWrapper = styled.div`
  width: ${scaleSize(1740)}px;
  overflow: hidden;
`;

const StyledTimeBlock = styled.div`
  display: inline-block;
  width: ${scaleSize(400)}px;
  font-size: 24px;
  color: ${({ theme }) => theme.epgTimeColor};
`;

interface IStyledLine {
  progress: number;
}

const StyledTimeLine = styled.div.attrs<IStyledLine>(({ progress }) => {
  const left = `${THRESHOLD_IN_PIXELS * 4 * progress}px`;
  return { style: { left } };
})<IStyledLine>`
  position: absolute;
  left: 0;
  top: ${scaleSize(55)}px;
  width: 2px;
  margin-left: ${scaleSize(22)}px;
  height: ${scaleSize(819)}px;
  background: #fff;
  z-index: 30;
`;

interface ITimebarProps {
  startTime: number;
  currentTime: number;
  endTime: number;
}

const TimeBar: React.FC<ITimebarProps> = ({ startTime, currentTime, endTime }) => {
  const progress = useMemo(() => {
    const start = startTime;
    const end = endTime;
    const range = end - start;
    const diff = currentTime - start;
    const progress = diff / range;

    return progress;
  }, [startTime, currentTime, endTime]);

  const range = useMemo(() => {
    return new Array(4).fill(null).map((_, i) => {
      const item = new Date(startTime + i * HALF_OF_HOUR);
      const hours = `${item.getHours()}`;
      const minutes = `0${item.getMinutes()}`.slice(-2);

      return `${hours}:${minutes}`;
    });
  }, [startTime]);

  return (
    <BlockWrapper>
      <StyledWrapper>
        {range.map((time, i) => (
          <StyledTimeBlock key={i}>{time}</StyledTimeBlock>
        ))}
      </StyledWrapper>
      <StyledTimeLine progress={progress} />
    </BlockWrapper>
  );
};

export default TimeBar;
